import { Injectable } from '@angular/core';
import { config } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private isProduction = config.production;

  debug(message: string, ...data: unknown[]): void {
    if (!this.isProduction) {
      console.log(`[DEBUG] ${message}`, ...data.map((d) => this.mask(d)));
    }
  }

  info(message: string, ...data: unknown[]): void {
    if (!this.isProduction) {
      console.info(`[INFO] ${message}`, ...data.map((d) => this.mask(d)));
    }
  }

  warn(message: string, ...data: unknown[]): void {
    console.warn(`[WARN] ${message}`, ...data.map((d) => this.mask(d)));
  }

  error(message: string, ...data: unknown[]): void {
    console.error(`[ERROR] ${message}`, ...data.map((d) => this.mask(d)));
  }

  private mask(value: unknown): unknown {
    if (typeof value === 'string' && value.length > 8) {
      return `${value.substring(0, 4)}****${value.substring(value.length - 4)}`;
    }
    return value;
  }
}
